import React, { useState } from "react";

const DifficultyRating = ({ onRate }) => {
  const [step, setStep] = useState(1); // 1 = choose rating, 2 = follow-up text
  const [selected, setSelected] = useState(null);
  const [feedback, setFeedback] = useState("");

  const levels = ["Easy", "Medium", "Hard"];

  const handleSelect = (level) => {
    setSelected(level);
    if (level === "Medium") {
      // Skip feedback step for Medium
      if (onRate) onRate(level, null);
      setStep(3); // finished
    } else {
      setStep(2);
    }
  };

  const handleSubmitFeedback = () => {
    if (onRate) onRate(selected, feedback);
    setStep(3); // finished
  };

  if (step === 3) {
    return (
      <p
        style={{ marginTop: "0.5rem", textAlign: "center", fontWeight: "600" }}
      >
        Thanks for your feedback! You rated: {selected}
      </p>
    );
  }

  if (step === 1) {
    return (
      <div
        style={{ fontSize: "0.7rem", marginTop: "0.5rem", textAlign: "center" }}
      >
        <p style={{ marginBottom: "0.2rem", fontWeight: "600" }}>
          How difficult was this challenge?
        </p>
        <div style={{ display: "flex", justifyContent: "center", gap: "6px" }}>
          {levels.map((level) => (
            <button
              key={level}
              onClick={() => handleSelect(level)}
              type="button"
              style={{
                fontSize: "0.65rem",
                padding: "2px 8px",
                borderRadius: "15px",
                border: "1px solid #7c3aed",
                background: "white",
                color: "#7c3aed",
                cursor: "pointer",
                userSelect: "none",
                minWidth: "50px",
                textAlign: "center",
              }}
              aria-label={`Rate difficulty as ${level}`}
            >
              {level}
            </button>
          ))}
        </div>
      </div>
    );
  }

if (step === 2) {
  return (
    <div
      style={{
        marginTop: "0.5rem",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        justifyContent: "center",
      }}
    >
      <p style={{ fontWeight: "600", margin: 0 }}>
        What did you find {selected.toLowerCase()}?
      </p>
      <textarea
        rows={1}
        value={feedback}
        onChange={(e) => setFeedback(e.target.value)}
        style={{
          fontSize: "1rem",
          padding: "6px 10px",
          height: "36px",
        }}
        placeholder={`Tell us what you found ${selected.toLowerCase()}...`}
      />

      <button
        onClick={handleSubmitFeedback}
        disabled={feedback.trim() === ""}
        style={{
          padding: "6px 12px",
          borderRadius: "12px",
          border: "none",
          background: "#7c3aed",
          color: "white",
          cursor: feedback.trim() === "" ? "not-allowed" : "pointer",
        }}
      >
        Submit
      </button>
    </div>
  );
}

};

export default DifficultyRating;
